import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormComponentLookup, EntryConfigInterface, PageConfigInterface, FormNavigationConfig, DefaultFormConfig } from '@ptl/forms';
import { FormPageComponentClass } from '@ptl/forms';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { FormConfig } from '@ptl/forms';
import { ConfirmationPageUrls } from 'src/app/angular-elements/shared/components/interfaces/confirmation-page-urls.interface';
// import { FormConfigUtilityService } from '../../../services/form-config-utility.service';
import { EnrollmentFormConfig } from '../../types/enrollment-form-config.interface';
import { DateService } from 'src/app/shared/services/date.service';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
//import * as moment from 'moment';
import moment from 'moment';
import { SeniorMarketsEnrollmentSubmissionService } from 'src/app/angular-elements/shared/services/enrollment/senior-markets/enrollment-submission.senior-markets';
import { DomSanitizer } from '@angular/platform-browser';
import { ENROLLMENT_FLOW } from '../configs/interfaces/enrollment-flow.enum';

@FormComponentLookup('page-individual-plan-review-v2')
@Component({
    selector: 'app-individual-page-review-v2',
    templateUrl: './individual-page-review-v2.component.html',
    styleUrls: ['./individual-page-review-v2.component.scss'],
    standalone: false
})

export class IndividualPageReviewV2Component extends FormPageComponentClass<FormNavigationConfig> implements OnInit {

  @ViewChild('individualPlanReview', { static: true }) reviewHtml: ElementRef;

  private alphaMap: Map<number, string> = (() => {
    const map = new Map();

    // Populate the map with all 26 letters of the alphabet
    for (let i = 0; i < 26; i++) {
      map.set(i, String.fromCharCode(65 + i));
    }

    return map;
  })();

  reviewConfigReady = false;
  shouldIncludeEdit = false; 
  confirmationPageUrls: ConfirmationPageUrls;
  formJson: EnrollmentFormConfig = null;
  pageValue: any;
  formattedEntries = [];

  private redirectMap: Map<string, string> = null;
  private isProducer = false;
  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private submissionCallbacks: SeniorMarketsEnrollmentSubmissionService,
    private dateUtility: DateService,
    private commonUtilityService: CommonUtilityService,
    private domSanatizer: DomSanitizer
  ) {
    super();
  }

  async ngOnInit() {

    /** If we're doing the review-only flow, after adding the dynamic pages, update the page correctly */
    if (this.formConfig.form.customConfigs.reviewOnly) {
      /** Shamelessly copied from plan-enrollment.component.ts */
      const reviewIndex = this.formConfig.pages.findIndex(page => page.pageType.toLowerCase().indexOf('review') !== -1);
      this.currentPage = reviewIndex; // hacky af.
    }

    this.initPageConfig();
  }

  public initPageConfigHook() {
    let i = 0;

    /**
     * Behavior for this appears to be as follows:
     * 1) Index to last page of relevant data
     * 2) Copy entries (controls)
     * 3) Remove entries ( temporarily )
     * 4) Push into current last page all previous entries ( controls )
     * 5) Re-add copied entries from 2
     */
    this.formConfig.pages[this.currentPage].entries = [];

    this.formConfig.pages.forEach((page: PageConfigInterface, pageNumber: number) => {

      // TODO: why did we make a new REVIEW Component when this one works fine??
      // sxeang\src\app\angular-elements\form-wrappers\plan-enrollment\formComponents\page-review\page-review.component.ts
      if (page.display === true && page.pageType !== 'individual-plan-review') {

        const sectionLabel = {
          order: 0,
          pageNumber,
          custom: {
            displaySeparator: 'true'
          },
          base: {
            componentType: 'inner-html',
            display: true,
            doNotAddAsControl: true,
            text: ''
          },
          formControlAttributes: {
            connectPath: 'individualMarket.enrollment',
            formControlName: 'benefits',
            label: page.pageHeader,
            placeHolder: 'Gender',
            getValueFromState: '',
            validators: [
              {
                type: 'required',
                value: true
              }
            ]
          }
        };

        if (pageNumber !== this.currentPage ){ // this.currentPage) {

          this.formConfig.pages[this.currentPage].entries.push(sectionLabel);

          for (const entry of page.entries) {
            entry['pageNumber'] = pageNumber;
          }

          const concatEntries = this.formConfig.pages[this.currentPage].entries.concat(page.entries);
          this.formConfig.pages[this.currentPage].entries = concatEntries;
        }
      }
    });

    this.formConfig.pages[this.currentPage].entries.sort((a, b) => {
      const aReviewOrder = (a.custom && a.custom.reviewOrder && Number(a.custom.reviewOrder)) || 1000;
      const bReviewOrder = (b.custom && b.custom.reviewOrder && Number(b.custom.reviewOrder)) || 1000;
      return aReviewOrder - bReviewOrder;
    });
    
    let dependentCount = 0;
    let lastIndex = 0
    console.log(this.formConfig.pages[this.currentPage].entries);
    this.formConfig.pages[this.currentPage].entries.forEach((value) => {
      lastIndex = this.formattedEntries.length;
      if(value.custom?.displaySeparator){
        //for each new page, make a tuple with page header and list of entries
        this.formattedEntries.push([value, []]);
      }else if((value.base?.foreverHidden && !value.custom?.displaySeparator)
        || value.base.componentType === "section-header" 
        || value.base.componentType === "inner-html" 
        || value.base.display === false 
        || this.retrieveEntry(value,true) === null)
      {
        //craft new dependent details header that has dependent # and add it to the entries list
        if(value.custom?.addDependentDetails === true){
          dependentCount += 1;
          const dependentHeader = this.addDependentHeader(dependentCount, value);
          this.formattedEntries[lastIndex-1][1].push(dependentHeader);
        }
        return;
      }else{
        this.formattedEntries[lastIndex-1][1].push(value);
      }
    });

    console.log(this.formattedEntries);

    this.confirmationPageUrls = {
      confirmationPageUrl: this.formConfig.form.customConfigs.confirmationPageUrl,
      maConfirmationPageUrl: this.formConfig.form.customConfigs.confirmationPageUrl,
      medigapConfirmationPageUrl: this.formConfig.form.customConfigs.medigapConfirmationPageUrl,
      whbConfirmationPageUrl: this.formConfig.form.customConfigs.whbConfirmationPageUrl,
      pdpConfirmationPageUrl: this.formConfig.form.customConfigs.pdpConfirmationPageUrl,
    };

    this.pageFormGroups = this.parseToFormGroup.toFormGroup(this.formConfig.pages[this.currentPage].entries);
    setTimeout(() => { this.reviewConfigReady = true; }, 100);

  }

  retrieveEntry(entry: EntryConfigInterface, valueExists?: boolean) {

    const isControlField = (
      entry.formControlAttributes &&
      entry.formControlAttributes.connectPath &&
      entry.formControlAttributes.formControlName
    );

    if (isControlField) {

      const payload = this.reducerUtilityService.getPayloadStates();
      const dataParsed = this.commonUtilityService.setNestedProperty(payload, entry.formControlAttributes.connectPath, 'IndividualPageReview');
      const value = dataParsed[entry.formControlAttributes.formControlName];

      if (entry.formControlAttributes.formControlName === 'noSSN' || entry.formControlAttributes.formControlName === 'spousenoSSN') {
        if (value) {
          /** We are requested to add this back, but there's no mention of whether it should be a toggle between "no ssn" and "value of actual ssn" */
          // delete dataParsed[entry.formControlAttributes.formControlName];
        }
      }

      if (valueExists) {
        if (value === undefined || value === null || value === '') {
          return null;
        }
        return !!value;
      }

      if (value !== null) {
        switch (entry.base.componentType) {
          case 'text-input':
            return value;
          case 'date-input':
          case 'coverage-dropdown-select':
            return this.dateUtility.getDateAsFormattedString(value.toString(), 'MM/DD/YYYY');
          case 'radio-input':
          case 'custom-radio-input':
            let radioValue = null;
            for (const option in entry.radioGroupAttributes.optionAttributes) {
              if (entry.radioGroupAttributes.optionAttributes[option].value === value) {
                radioValue = entry.radioGroupAttributes.optionAttributes[option].label;
              }
            }
            return radioValue;
          case 'dropdown-select':
            let dropdownValue = null;
            for (const option in entry.selectAttributes.optionAttributes) {
              if (entry.selectAttributes.optionAttributes[option].value === value) {
                dropdownValue = entry.selectAttributes.optionAttributes[option].label;
              }
            }
            return dropdownValue;

          case 'checkbox-input':
          case 'custom-checkbox-input':
            return this.convertTruthyFalsyToString(value);
          case 'custom-date-input':
            return moment(value).format('MM/DD/YYYY');
          case 'date-of-birth-input':
            return moment(value).format('MM/DD/YYYY');
          default:
            return value;
        }
      }
    }

    return false
  }

  /** For use with non-control entries ( like specified legal text that is present on review/print ) */
  retrieveSafeHTML(entry: EntryConfigInterface) {

    if (entry?.custom?.textSafeHtml) {
      return this.domSanatizer.bypassSecurityTrustHtml(entry.base.text);
    }

    return entry?.base?.text
  }

  nextHook(formConfig): Promise<any> {
    const content = this.reviewHtml.nativeElement.innerText
    // + '\n';
    const serializedState = this.commonUtilityService.base64decode(sessionStorage.getItem('applicationForm')) || 'Your Application:\n';
    if (!serializedState.includes('content')) {
      sessionStorage.setItem('applicationForm', this.commonUtilityService.base64encode(serializedState + content));
    }
    return new Promise((resolve, reject) => {
      this.formPageActions.nextHook(formConfig);
      resolve(resolve);
    });
  }

  submitHook(formConfig): Promise<any> {
    return new Promise((resolve, reject) => {
      // Old Copy/Paste Senior Code - the senior code has a page-review component with submission, this was not removed when bringing it over
      // this.saveApplicationToStorageForConfirmationPage();
      resolve(true);
    });
  }

  editQuestion(entry) {
    const controlName = entry.formControlAttributes?.formControlName;
    const urlRedirect = this.formConfig?.pages[entry.pageNumber]?.custom?.redirectUrl;

    if (urlRedirect) {
      this.redirectMap = new Map(urlRedirect.split(/\s*,\s*/).map(oepRedirectUrls => oepRedirectUrls.split('=')));
    }
    if (urlRedirect && controlName && (controlName === 'dob' || controlName === 'tobaccoIndicator')) {
      window.location.assign(this.redirectMap.get('aboutyouoep'));
    } else if (urlRedirect && controlName && controlName === 'zipCode' && entry.pageNumber === 0) {
      window.location.assign(this.redirectMap.get('viewplansoep'));
    }  else {
      this.emitCustomPage(entry.pageNumber);
    }
  }

  saveApplicationToStorageForConfirmationPage() {
    const content = this.reviewHtml.nativeElement.innerText + '\n';
    const serializedState = this.commonUtilityService.base64decode(sessionStorage.getItem('applicationForm')) || 'Your Application:\n';
    if (!/content/.test(serializedState)) {
      sessionStorage.setItem('applicationForm', this.commonUtilityService.base64encode(serializedState + content));
    }
    this.submissionCallbacks.submitPayload(this.confirmationPageUrls);
  }

  convertTruthyFalsyToString(value, returnTruthyString?, returnFalseyString?) {
    let returnValue = value ? value : 'Not Answered';

    if (['Yes', 'yes', 'YES', true, 'true', 'Y', 'y'].includes(value)) {
      returnValue = returnTruthyString || 'Yes';
    }
    if (['No', 'no', 'NO', false, 'false', 'N', 'n'].includes(value)) {
      returnValue = returnFalseyString || 'No';
    }

    return returnValue;
  }

  isLongString(entry){
    const maxStringLength = 75;
    const entryLength = entry?.length || 0;
    return entryLength > maxStringLength;
  }
  
  addDependentHeader(dependentCount: number, value: EntryConfigInterface): EntryConfigInterface{
    const dependentHeader = {
      order: +value.order + 1,
      pageNumber: value.pageNumber,
      custom: {
        dependentHeader: 'true',
        dependentNum: dependentCount
      },
      base: {
        componentType: 'inner-html',
        display: true,
        doNotAddAsControl: true,
        text: ''
      },
      formControlAttributes: {
        connectPath: 'individualMarket.enrollment',
        formControlName: 'benefits',
        label: "Dependent " + (value.custom?.swapTextIndexForTextAlpha ? this.alphaMap.get(dependentCount-1) : dependentCount),
        placeHolder: 'Gender',
        getValueFromState: '',
        validators: [
          {
            type: 'required',
            value: true
          }
        ]
      }
    };

    return dependentHeader;
  }
}
